import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface PreviewNoticeDialogProps {
  readonly onClose: () => void;
}

/** 상품 미리보기 준비 중 안내 — 사용자용 상품 페이지가 생기면 실 미리보기로 교체된다. */
export const PreviewNoticeDialog = ({ onClose }: PreviewNoticeDialogProps): ReactElement => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground/40">
    <div
      role="dialog"
      aria-modal="true"
      aria-label="상품 미리보기 안내"
      className="w-80 rounded-lg border bg-background p-5 shadow-lg"
    >
      <p className="font-medium">상품 미리보기</p>
      <p className="mt-2 text-sm text-muted-foreground">
        사용자 화면 미리보기 기능은 추가 예정입니다. 사용자용 상품 페이지가 준비되면 이 버튼에서
        바로 열립니다.
      </p>
      <div className="mt-4 text-right">
        <Button size="sm" onClick={onClose}>
          확인
        </Button>
      </div>
    </div>
  </div>
);
